import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Configuration } from '../../../app.constants';
import FundTypes from '../../../_core/constants/fund-types';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss'],
  standalone: false,
})
export class BankDetailsComponent implements OnInit, OnChanges {
  @Input() onlineBanking: boolean;
  @Input() physicalCheck: boolean;
  @Input() taxDeduction: boolean;
  @Input() instructionIndex: number | null = null;
  @Input() fundType: FundTypes | undefined;

  wiringInstructions: any;
  eftInstructions: any;
  tenantName: string;
  cncfDonateEmail: string;

  get bankWiringInstructions(): any[] {
    return this.wiringInstructions.filter((instructions: { taxDeduction?: boolean }) =>
      typeof instructions.taxDeduction === 'boolean'
        ? instructions.taxDeduction === (this.fundType === FundTypes.DAF ? true : this.taxDeduction)
        : true
    );
  }

  constructor(private config: Configuration) {}

  ngOnInit(): void {
    this.wiringInstructions =
      this.instructionIndex !== null
        ? [this.config.wiringInstructions[this.instructionIndex]]
        : this.config.wiringInstructions;
    this.eftInstructions = this.config.eftInstructions;
    this.tenantName = this.config.name;
    this.cncfDonateEmail = 'donate@cncf.ca';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.instructionIndex?.currentValue &&
      changes.instructionIndex?.previousValue !== changes.instructionIndex?.currentValue
    ) {
      this.wiringInstructions = [this.config.wiringInstructions[this.instructionIndex]];
    }
  }

  isWireRoutingNumber(fieldName: string): boolean {
    return fieldName === 'donate.wire.routing.number';
  }
}
